var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRightYellow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 14,
    viewBox: "0 0 26 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "mr0etou0la",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.996078 0 0 0 0 0.772549 0 0 0 0 0.141176 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#mr0etou0la)",
    transform: "translate(-707.000000, -283.000000) translate(163.000000, 150.000000) translate(105.000000, 24.000000) translate(310.000000, 53.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE24F",
    d: "M18.97 0L26 7l-7.03 7H13l5.024-5H0V5h18.025L13 0h5.97z",
    transform: "translate(129.000000, 56.000000)"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightYellow);
export default __webpack_public_path__ + "static/media/arrow-right-yellow.6e6be910916d9d63c027f047416efb42.svg";
export { ForwardRef as ReactComponent };